import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Button, Reveal, Label, Icon } from 'semantic-ui-react';
import 'rc-time-picker/assets/index.css';
import moment from 'moment-timezone';
import TimePicker from 'rc-time-picker';

import { StaffSearchModal, StoreSearchModal } from 'components/Commons';

import * as cmAction from 'actions/commons';
import toastr from 'helpers/toastr';
import DetailGroupList from './DetailGroupList';

moment.tz.setDefault('Asia/Seoul');

class DetailSikdaeSelectForm extends Component {
  constructor() {
    super();
    this.state = {
      // 상세검색 사용자, 가맹점
      staffModal: {
        open: false,
        size: 'large'
      },
      storeModal: {
        open: false,
        size: 'large'
      },
      // 상세검색 펼치기 아이콘
      icon: 'plus',
      visible: 'hidden'
    };
  }

  componentWillMount() {
    const now = moment().hour(0);
    const { timeChange } = this.props.selectFn;
    timeChange('sTime', now);
    timeChange('eTime', now);
  }

  onChangeTime = (time, type) => {
    const { hour } = this.props;
    const { timeChange } = this.props.selectFn;

    if (type === 'sTime' && time.format('HH') > hour.eTime) {
      toastr('top-right', 'warning', '시작시각을 종료시각 이전으로 선택해주세요.');
    } else if (type === 'eTime' && time.format('HH') < hour.sTime) {
      toastr('top-right', 'warning', '종료시각을 시작시각 이후로 선택해주세요.');
    } else {
      timeChange(type, time);
    }
  };

  toggleBox = () => {
    const { icon, visible } = this.state;
    this.setState({
      icon: icon === 'plus' ? 'minus' : 'plus',
      visible: visible === 'hidden' ? 'visible' : 'hidden'
    });
  };

  /* ---start--- 사용자, 가맹점 검색 */
  searchClick = (type) => {
    if (type === 'staff') {
      this.modalAction('open', true);
    } else {
      this.storeModalAction('open', true);
    }
  };

  modalAction = (type, dimmer) => {
    if (type === 'open') {
      this.staffSel(1, null);
    }
    this.setState({
      dimmer,
      staffModal: { open: dimmer }
    });
  };

  storeModalAction = (type, dimmer) => {
    if (type === 'open') {
      this.storeSel(1, null);
    }
    this.setState({
      dimmer,
      storeModal: { open: dimmer }
    });
  };

  staffSel = async (page, keyword) => {
    const { cmAPI } = this.props;
    const params = {
      page,
      pagerow: 10,
      keyword
    };

    try {
      await cmAPI.staffSel(params);
    } catch (e) {
      console.log('###### staffSel error : ', e);
    } finally {
    }
  };

  storeSel = async (page, keyword) => {
    const { cmAPI } = this.props;
    const params = {
      page,
      pagerow: 10,
      keyword,
      isactive: null
    };

    try {
      await cmAPI.storeSel(params);
    } catch (e) {
      console.log('###### storeSel error : ', e);
    }
  };

  choiceStaff = (data) => {
    this.setState({
      staffModal: { open: false }
    });
    const { addChoiceEvent } = this.props.selectFn;
    const obj = {
      name: data.staff.name,
      id: data.staff.id,
      signId: data.staff.signid
    };
    addChoiceEvent(obj, 'user');
  };

  choiceStore = (name, id) => {
    this.setState({
      storeModal: { open: false }
    });

    const { addChoiceEvent } = this.props.selectFn;
    const obj = {
      name,
      id,
      signId: id
    };
    addChoiceEvent(obj, 'store');
  };
  /* ---end--- */

  render() {
    const { staffModal, storeModal, dimmer, icon, visible } = this.state;
    const {
      user,
      store,
      startTime,
      endTime,
      sgl_use,
      mul_use,
      sgl_cancel,
      mul_cancel,
      initialize,
      delChoiceEvent,
      groupSel,
      policySel,
      paymentOption,
      clickEvent
    } = this.props.selectFn;
    const modal = {
      open: staffModal.open,
      size: staffModal.size,
      dimmer,
      close: this.modalAction
    };
    const modal2 = {
      open: storeModal.open,
      size: storeModal.size,
      dimmer,
      close: this.storeModalAction
    };
    const sb = {
      fn: {
        choiceStaff: this.choiceStaff,
        choiceStore: this.choiceStore
      }
    };
    const paymentCheckboxStyle = {
      width: '150px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    };

    let storeList = '';
    if (store && store.length > 0) {
      storeList = store.map((item) => {
        return (
          <Label color="black" key={item.id}>
            {item.name}
            <Icon name="close" onClick={() => delChoiceEvent(item.id, 'store')} />
          </Label>
        );
      });
    }

    let staffList = '';
    if (user && user.length > 0) {
      staffList = user.map((item) => {
        return (
          <Label color="black" key={item.id}>
            {item.name}
            <Icon name="close" onClick={() => delChoiceEvent(item.id, 'user')} />
          </Label>
        );
      });
    }
    return (
      <div className="dtl-form">
        <Grid divided="vertically" className="fixed-box sel-box" onClick={this.toggleBox}>
          <Grid.Row className="clearfix">
            <Icon name={icon} />
            <Grid.Column className="left" style={{ marginLeft: 20 }}>
              상세조건 검색
            </Grid.Column>
            <Button
              className="select-reset-btn"
              style={{
                marginRight: '1.5rem',
                position: 'absolute',
                right: 0,
                background: '#ffffff'
              }}
              color="black"
              inverted
              content="선택 초기화"
              onClick={initialize}
            />
          </Grid.Row>
        </Grid>
        <Reveal animated="move up" disabled style={{ zIndex: 0 }}>
          <Reveal.Content className={visible}>
            <Grid className="tg-box">
              <Grid.Row className="sel-box">
                <Grid.Column className="left">
                  <span>제휴식당</span>
                </Grid.Column>
                <Grid.Column className="right">
                  <Button
                    className="label-btn"
                    content="제휴식당"
                    icon="plus"
                    labelPosition="left"
                    onClick={() => this.searchClick('store')}
                  />
                  <Label.Group className="labels-ls">{storeList}</Label.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="sel-box">
                <Grid.Column className="left">
                  <span>사용자</span>
                </Grid.Column>
                <Grid.Column className="right">
                  <Button
                    className="label-btn"
                    content="사용자"
                    icon="plus"
                    labelPosition="left"
                    onClick={() => this.searchClick('staff')}
                  />
                  <Label.Group className="labels-ls">{staffList}</Label.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="sel-box clearfix">
                <Grid.Column className="left line-height-not">
                  <span>그룹</span>
                </Grid.Column>
                <Grid.Column className="right">
                  <DetailGroupList groupSel={groupSel} policySel={policySel} clickEvent={clickEvent} />
                  {/* {groupList} */}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="sel-box">
                <Grid.Column className="left">
                  <span>시간</span>
                </Grid.Column>
                <Grid.Column className="right">
                  <div className="form-hourpicker">
                    <Icon.Group className="cm-time hour-picker">
                      <Icon bordered name="wait" />
                      <TimePicker
                        defaultValue={moment(new Date(startTime))}
                        defaultOpenValue={moment(new Date(startTime))}
                        onChange={(e) => this.onChangeTime(e, 'sTime')}
                        showMinute={false}
                        showSecond={false}
                        popupClassName="TimePop"
                        value={startTime}
                      />
                    </Icon.Group>
                    <Icon name="minus" className="timepicker-bar" />
                    <Icon.Group className="cm-time hour-picker">
                      <Icon bordered name="wait" />
                      <TimePicker
                        defaultValue={moment(new Date(endTime))}
                        defaultOpenValue={moment(new Date(endTime))}
                        onChange={(e) => this.onChangeTime(e, 'eTime')}
                        showMinute={false}
                        showSecond={false}
                        popupClassName="TimePop"
                        value={endTime}
                      />
                    </Icon.Group>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="sel-box">
                <Grid.Column className="left line-height-not">
                  <span>결제형태</span>
                </Grid.Column>
                <Grid.Column className="right payment-checkbox">
                  <li>
                    <div className="checkbox pure group mg24" style={paymentCheckboxStyle}>
                      <label>
                        <input
                          type="checkbox"
                          className="hidden"
                          name="sgl_use"
                          style={{ display: 'none' }}
                          checked={sgl_use}
                          onChange={paymentOption}
                        />
                        <span />
                        <div className="payment-name">개인결제</div>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox pure group mg24" style={paymentCheckboxStyle}>
                      <label>
                        <input
                          type="checkbox"
                          className="hidden"
                          name="mul_use"
                          style={{ display: 'none' }}
                          checked={mul_use}
                          onChange={paymentOption}
                        />
                        <span />
                        <div className="payment-name">함께결제</div>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox pure group mg24" style={paymentCheckboxStyle}>
                      <label>
                        <input
                          type="checkbox"
                          className="hidden"
                          name="sgl_cancel"
                          style={{ display: 'none' }}
                          checked={sgl_cancel}
                          onChange={paymentOption}
                        />
                        <span />
                        <div className="payment-name">개인취소</div>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox pure group mg24" style={paymentCheckboxStyle}>
                      <label>
                        <input
                          type="checkbox"
                          className="hidden"
                          name="mul_cancel"
                          style={{ display: 'none' }}
                          checked={mul_cancel}
                          onChange={paymentOption}
                        />
                        <span />
                        <div className="payment-name">함께취소</div>
                      </label>
                    </div>
                  </li>
                  {/* <Checkbox className='group mg24' label='개인결제' name='sgl_use' checked={sgl_use} onChange={paymentOption} />
                  <Checkbox className='group mg24' label='함께결제' name='mul_use' checked={mul_use} onChange={paymentOption} />
                  <Checkbox className='group mg24' label='개인취소' name='sgl_cancel' checked={sgl_cancel} onChange={paymentOption} />
                  <Checkbox className='group mg24' label='함께취소' name='mul_cancel' checked={mul_cancel} onChange={paymentOption} /> */}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Reveal.Content>
        </Reveal>

        <StaffSearchModal modal={modal} staffSel={this.staffSel} choiceEvent={this.choiceStaff} />
        <StoreSearchModal modal={modal2} storeSel={this.storeSel} choiceEvent={this.choiceStore} />
      </div>
    );
  }
}

DetailSikdaeSelectForm = connect(
  (state) => ({
    division: state.commons.division,
    sikPolicy: state.commons.sikdaePolicy,
    depth: state.commons.depth,
    hour: state.commons.hour
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        staffSel: cmAction.StaffSel,
        storeSel: cmAction.StoreList
      },
      dispatch
    )
  })
)(DetailSikdaeSelectForm);

export default DetailSikdaeSelectForm;
